export const ClientInfoKeys = Object.freeze({
  BROWSER_NAME: 'BROWSER_NAME',
  BROWSER_VERSION: 'BROWSER_VERSION',
  OS_NAME: 'OS_NAME',
  OS_VERSION: 'OS_VERSION',
  BROWSER_SUPPORT: 'BROWSER_SUPPORT',
  HAS_DISMISSED_BROWSER_BAR: 'HAS_DISMISSED_BROWSER_BAR',
  IS_ELECTRON: 'IS_ELECTRON',
} as const);

export const BrowserSupportLevels = Object.freeze({
  NONE: 'NONE',
  BASIC: 'BASIC',
  FULL: 'FULL',
} as const);

export const OsNames = Object.freeze({
  ANDROID: 'Android',
  IOS: 'iOS',
  WINDOWS: 'Windows',
} as const);

export const ClientVersionSemverRegex = new RegExp(/\d+[.]\d+[.]\d/);
